import makeService from './api';

export default makeService('add_transfers_to_runs');
